import CopyRightSection from "./CopyRightSection";
import TopFooterSection from "./TopFooterSection";
import SupportInfo from "./supportInfo";

// eslint-disable-next-line import/no-default-export
export default function FooterSection() {

  return (
    <footer className="bg-light-80 p-7 ">
      <SupportInfo />
      <TopFooterSection />
      <CopyRightSection />
    </footer>
  )
}